import {
  faChildren,
  faHomeHeart,
  faHourglassHalf,
} from "@fortawesome/duotone-light-svg-icons"
import { faPause } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DoterSpecies, JoonUIColor, Typography } from "@joonapp/web-shared"

import { UserSelectFilterType } from "../../types"
import NotificationDot2 from "../notificationDot/NotificationDot2"
import ParentAvatar from "../parentAvatar/ParentAvatar"

const UserSelectHeaderButton = ({
  label,
  imageUrl,
  parentAvatar,
  filterType,
  onClick,
  isSelected,
  isPaused = false,
  isRestrictedScreenTime = false,
  hasNotification = false,
}: {
  label: string
  imageUrl: string | null
  parentAvatar: DoterSpecies | null
  filterType: UserSelectFilterType
  onClick: () => void
  isSelected: boolean
  isPaused?: boolean
  isRestrictedScreenTime?: boolean
  hasNotification?: boolean
}) => {
  return (
    <button onClick={onClick}>
      <div className="flex flex-col items-center justify-center gap-1 user-select-none min-w-11 max-w-11">
        <div className="relative">
          {imageUrl ? (
            <>
              <img
                src={imageUrl}
                alt="avatar"
                draggable="false"
                className={`${isSelected ? "border-primary" : "border-transparent"} border-3 rounded-full object-contain object-center min-w-10 min-h-10 max-w-10 max-h-10`}
              />
              {hasNotification && (
                <div className="absolute top-[2px] right-0">
                  <NotificationDot2 />
                </div>
              )}
            </>
          ) : parentAvatar ? (
            <ParentAvatar
              avatar={parentAvatar}
              size={40}
              className={`${isSelected ? "border-primary" : "border-transparent"}  border-3 rounded-full`}
            />
          ) : (
            <div
              className={`${isSelected ? "border-3 border-primary bg-indigo-100" : "border-borderPrimary bg-white border-1"}  rounded-full min-w-10 min-h-10 max-w-10 max-h-10 items-center flex justify-center`}
            >
              <FontAwesomeIcon
                icon={
                  filterType === UserSelectFilterType.ALL_KIDS
                    ? faChildren
                    : faHomeHeart
                }
                color={
                  isSelected
                    ? JoonUIColor.icon.accent
                    : JoonUIColor.icon.neutral
                }
              />
            </div>
          )}
          {(isPaused || isRestrictedScreenTime) && (
            <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black/50">
              {isPaused ? (
                <FontAwesomeIcon
                  icon={faPause}
                  color={JoonUIColor.icon.inverted}
                  className="w-5 h-5"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faHourglassHalf}
                  color={JoonUIColor.icon.inverted}
                  className="w-5 h-5"
                />
              )}
            </div>
          )}
        </div>
        <Typography
          variant={isSelected ? "bodyXSmallBold" : "bodyXSmall"}
          color={
            isSelected
              ? JoonUIColor.text.primaryAccent
              : JoonUIColor.text.primary
          }
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
        >
          {label}
        </Typography>
      </div>
    </button>
  )
}

export default UserSelectHeaderButton
